import { Controller } from "stimulus";

export default class extends Controller {
  scroll() {
    window.scroll(this.element.offsetTop, this.element.offsetLeft)
  }
}
